
import { useCallback } from 'react';
import { Editor } from '@tiptap/react';

export const useEditorShortcuts = (editor: Editor | null) => {
  return useCallback((e: React.KeyboardEvent) => {
    if (!editor) return;
    
    // Ctrl/Cmd + B for bold
    if ((e.ctrlKey || e.metaKey) && e.key === 'b') {
      e.preventDefault();
      editor.chain().focus().toggleBold().run();
    }
    
    // Ctrl/Cmd + I for italic
    if ((e.ctrlKey || e.metaKey) && e.key === 'i') {
      e.preventDefault();
      editor.chain().focus().toggleItalic().run();
    }
    
    // Ctrl/Cmd + U for underline
    if ((e.ctrlKey || e.metaKey) && e.key === 'u') {
      e.preventDefault();
      editor.chain().focus().toggleUnderline().run();
    }
    
    // Ctrl/Cmd + Z for undo
    if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) {
      e.preventDefault();
      editor.chain().focus().undo().run();
    }
    
    // Ctrl/Cmd + Shift + Z for redo
    if ((e.ctrlKey || e.metaKey) && e.key === 'z' && e.shiftKey) {
      e.preventDefault();
      editor.chain().focus().redo().run();
    }
  }, [editor]);
};
